import React, { useEffect } from "react";
import { ThemeProvider, createTheme, initializeIcons } from "@fluentui/react";

const theme = createTheme({
    palette: {
      themePrimary: '#31ce57',
      themeLighterAlt: '#f5fdf7',
      themeLighter: '#d9f7e1',
      themeLight: '#baf0c7',
      themeTertiary: '#7be295',
      themeSecondary: '#46d46a',
      themeDarkAlt: '#2dba50',
      themeDark: '#269d44',
      themeDarker: '#1c7432',
      neutralLighterAlt: '#f8f8f8',
      neutralLighter: '#f4f4f4',
      neutralLight: '#eaeaea',
      neutralQuaternaryAlt: '#dadada',
      neutralQuaternary: '#d0d0d0',
      neutralTertiaryAlt: '#c8c8c8',
      neutralTertiary: '#595959',
      neutralSecondary: '#373737',
      neutralPrimaryAlt: '#2f2f2f',
      neutralPrimary: '#000000',
      neutralDark: '#151515',
      black: '#0b0b0b',
      white: '#ffffff',
}});

const Theme: React.FC = props => {

    useEffect(() => {
        initializeIcons();
    }, []);

    return (
        <ThemeProvider theme={theme}>
            {props.children}
        </ThemeProvider>
    );
};

export default Theme;